import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { IMenuConfig, IHeaderTitle, IHeaderMenu } from '@uw-verisk/common-ui';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { AppState } from 'src/app/store/app.state';
import { AppService } from 'src/app/app.service';
import { IAppConfig } from 'src/app/models/config';
import { OktaUserInfoService } from 'src/app/core/okta-user-info.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  profile: string;
  appConfig: IAppConfig;
  title :IHeaderTitle;
  listMenuItems: IHeaderMenu[] = [
  {
    label: 'Logout',
    eventName: 'logout'
  }];

  constructor(private appService : AppService,
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    private router: Router, private store: Store<AppState>,
    private oktaUserInfoService: OktaUserInfoService) {
  }

  async ngOnInit(){
    this.appConfig = this.appService.readConfig();
    this.title = {
      name: this.appConfig.applicationName,
    };

    this.oktaUserInfoService.getUserInfo().subscribe(user => {
      this.profile = user.preferred_username;

      if(!this.appConfig.isFederated) {
        this.listMenuItems.unshift({
          label: 'Configure MFA',
          eventName: 'configureMFA'
        });
      }
    });
  }


  onMenuItemClick(item: IHeaderMenu) {
    switch (item.eventName) {
      case 'configureMFA':
        this.navigateTo(this.appConfig.gatewayAccountSettingsUrl);
        break
      case 'logout':
        this.onLogout();
        break;
      default:
        console.warn('Unknown menu item clicked:', item);
    }
  }

  navigateTo(url: string) {
    window.open(url, '_blank');
  }

  public onLogout() {
    this.oktaAuth?.signOut();
  }

  onTitleClick() {
    this.router.navigateByUrl('/');
  }
}
